/**
 * userInfoApi  用户信息类 api 接口
 *
 * @Author  Carey.zhou
 * @DATE    create on 2019/9/16
 * @DESC
 */

import { ajax } from './createApi'
import { shopBaseUrl, truckBaseUrl } from './urlConfig'
import jsonp from 'jsonp'
/**
 * 获取用户商城信息
 */
export function getUserShopInfo() {
  return ajax({
    method: 'GET',
    url: `${shopBaseUrl}/optimize/getShopInfo`,
    data: null
  })
}

/**
 *
 * 获取用户手机信息
 * @export
 * @param {*} params
 * @returns
 */
export function getUserPhoneInfo(params) {
  return ajax({
    method: 'GET',
    url: `${truckBaseUrl}/user/baseInfo`,
    data: params
  })
}

/**
 *
 * 获取用户的userid
 * @export
 * @returns
 */
// 正式版的
export function getUserInfo() {
  const { NODE_ENV, VUE_APP_SSO_API, VUE_APP_SSO_HOST} = process.env
  if (NODE_ENV === 'development') {
    return ajax({
      method: 'GET',
      url: VUE_APP_SSO_API,
      data: null,
      baseURL: VUE_APP_SSO_HOST
    })
  } else {
    return new Promise((resolve) => {
      jsonp(VUE_APP_SSO_HOST + VUE_APP_SSO_API, {}, (err, data) => {
        console.log('用户的信息', data)
        if (data.code === 200) {
          data.isSuccess = true
          resolve(data)
        }
      })
    })
  }
}

/**
 *
 *  判断用户是否参加过活动
 * @export
 */
export function getUseActivity() {
  return ajax({
    method: 'GET',
    url: '/truck/activity/optimize/getHomeInfo',
    data: null
  })
}


export function getUserAuthenticationStatus() {
  return ajax({
    method: 'GET',
    url: '/truck/api/conclusion/getHomeInfo',
    data: {
      dictionariesType: '2,5,7'
    }
  })
}

/**
 *
 *
 * @export 新用户上传行驶证图片
 * @param {*} data 传给后台的数据
 */
export function userVehicleLicense(data) {
  return ajax({
    method: 'POST',
    url: '/truck/api/auth/scan/vehicle/license',
    data
  })
}

/**
 *
 * 新用户上传车架号
 * @export
 * @param {*} data
 */
export function userCheckVnoAuth(data) {
  return ajax({
    method: 'POST',
    url: '/truck/api/auth/checkVnoAuth',
    data
  })
}

/**
 *
 * 获取用户是否可以参加积分兑换转盘活动
 * @export
 * @returns
 */
export function getShowBubbleIntegral() {
  return ajax({
    method: 'GET',
    url: '/truck/activity/recallTurnTable/showHomeInfoBubble',
    data: null
  })
}